// Where the Microsoft sign-in popup returns, and how a page load recognises
// it. Kept free of MSAL so src/index.js can check it cheaply and it can be
// unit tested on its own.
export const MSAL_REDIRECT_PATH = '/login';

// True when this page load is the sign-in popup returning from Entra: the
// redirect path with an auth response (code or error, plus MSAL's state) in
// the hash. Not keyed on window.opener: Entra's pages sever it.
export const isMsalPopupResponse = () => {
    const { pathname, hash } = window.location;
    const hasState = /[#&]state=/.test(hash);
    const hasResponse = /[#&](code|error)=/.test(hash);
    return pathname === MSAL_REDIRECT_PATH && hasState && hasResponse;
};
